import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import BottomNav from './components/BottomNav';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Shop from './pages/Shop';
import PhysioHelp from './pages/PhysioHelp';
import Jobs from './pages/Jobs';
import ProviderDetail from './pages/ProviderDetail';
import './App.css';
import RehabNotificationsViewAll from './pages/RehabNotifications';
import RehabNotificationDetail from './pages/RehabNotificationDetail';
import NotificationsViewAll from './pages/NotificationsViewAll';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <Navbar />
              <Home />
              <div style={{ height: '70px' }}></div>
              <BottomNav />
            </>
          } />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/provider/:id" element={<ProviderDetail />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/physio-help" element={<PhysioHelp />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/users" element={React.createElement(require('./pages/UserList').default)} />
          <Route path="/rehab-notifications" element={<RehabNotificationsViewAll />} />
          <Route path="/rehab-notifications/:id" element={<RehabNotificationDetail />} />
          <Route path="/notifications" element={<NotificationsViewAll />} />
          <Route path="/notifications/:id" element={<RehabNotificationDetail />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
